import { FormEvent, useState } from 'react';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { createVenue, deleteVenue, getVenuePack, listVenues } from '../api/portal';
import { ApiError } from '../api/client';
import { copyText } from '../lib/clipboard';

export function VenuesPage() {
  const qc = useQueryClient();
  const venues = useQuery({ queryKey: ['portal-venues'], queryFn: listVenues });
  const [name, setName] = useState('');
  const [origin, setOrigin] = useState('');
  const [delay, setDelay] = useState(7000);
  const [msg, setMsg] = useState<string | null>(null);

  const create = useMutation({
    mutationFn: () => createVenue({ name: name.trim(), origin: origin.trim() || undefined, delay_ms: delay }),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['portal-venues'] });
      setName('');
      setOrigin('');
      setMsg('Dvorana dodata.');
    },
    onError: (e) => setMsg(e instanceof ApiError ? e.message : String(e)),
  });
  const remove = useMutation({
    mutationFn: deleteVenue,
    onSuccess: () => qc.invalidateQueries({ queryKey: ['portal-venues'] }),
  });

  return (
    <div>
      <div className="page-head">
        <div className="page-kicker">Liga</div>
        <h1 className="page-title">Dvorana / LED</h1>
        <p className="page-sub">
          LED pack sada iframe-uje Origo On-Air (scorebug + replay). Fallback su i dalje live-score / goal-bug widgeti.
        </p>
      </div>
      <form
        className="card mb-4 grid gap-3 p-4 md:grid-cols-4"
        onSubmit={(e: FormEvent) => { e.preventDefault(); create.mutate(); }}
      >
        <div>
          <label className="label">Hala</label>
          <input className="input" value={name} onChange={(e) => setName(e.target.value)} required placeholder="SC Morača" />
        </div>
        <div>
          <label className="label">Host (opciono)</label>
          <input className="input" value={origin} onChange={(e) => setOrigin(e.target.value)} placeholder="led.hala.rs" />
        </div>
        <div>
          <label className="label">Delay ms</label>
          <input className="input" type="number" min={0} value={delay} onChange={(e) => setDelay(Number(e.target.value))} />
        </div>
        <div className="flex items-end">
          <button className="btn-primary" disabled={create.isPending}>Dodaj ekran</button>
        </div>
      </form>
      {msg && <div className="card mb-3 p-3 text-sm text-slate-200">{msg}</div>}
      <div className="card p-4">
        <table className="table">
          <thead>
            <tr><th>Hala</th><th>Delay</th><th></th></tr>
          </thead>
          <tbody>
            {(venues.data ?? []).map((v) => (
              <tr key={v.id}>
                <td className="text-white">{v.name}{v.origin ? <span className="ml-2 text-xs text-slate-500">{v.origin}</span> : null}</td>
                <td className="tabular-nums text-slate-400">{v.delay_ms} ms</td>
                <td className="flex flex-wrap gap-1">
                  <button
                    type="button"
                    className="btn-primary text-xs"
                    onClick={() => getVenuePack(v.id).then((p) => copyText(p.html)).then(() => setMsg(`Pack za ${v.name} kopiran.`))}
                  >
                    Copy pack
                  </button>
                  <button type="button" className="btn-ghost text-xs" onClick={() => remove.mutate(v.id)}>Ukloni</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {(venues.data ?? []).length === 0 && (
          <div className="py-6 text-center text-sm text-slate-500">Još nema LED ekrana.</div>
        )}
      </div>
    </div>
  );
}
